import { ChevronLeft } from '@mui/icons-material';
import { Box, IconButton, Link, Breadcrumbs as MuiBreadcrumbs, SxProps, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface Breadcrumb {
  label: ReactNode;
  to?: string;
}

export interface BreadcrumbsProps {
  items: Breadcrumb[];
  sx?: SxProps;
}

const Breadcrumbs = ({ items, sx = {} }: BreadcrumbsProps) => {
  const prev = items[items.length - 2];

  return (
    <Box sx={{ alignItems: 'center', ml: 8, mt: 1, display: 'flex', ...sx }}>
      {prev?.to ? (
        <IconButton color="inherit" component={RouterLink} to={prev.to} sx={{ mr: 2 }}>
          <ChevronLeft />
        </IconButton>
      ) : null}
      <MuiBreadcrumbs sx={{ lineHeight: '40px' }}>
        {items.map((item, i) =>
          !item.to || (i === items.length - 1 && items.length > 1) ? (
            <Typography
              key={item.to ?? item.label?.toString() ?? i}
              component="span"
              color="text.primary"
              variant="body1"
            >
              {item.label}
            </Typography>
          ) : (
            <Link
              component={RouterLink}
              color="text.secondary"
              key={item.to}
              sx={{ textDecoration: 'none' }}
              to={item.to}
              variant="body1"
            >
              {item.label}
            </Link>
          ),
        )}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
